import React, { useCallback, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { useLocation } from "react-router-dom";
import FlightIcon from "../../assets/img/plane.png";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconBack from "@material-ui/icons/ArrowBack";
import moment from "moment";
import { useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import ContactDetail from "./ContactDetail";
import { connect, useDispatch, useSelector } from "react-redux";
import { toggleSignUp, getUserDetails } from "../../store/actions/user/User";
import { getVendorDetails } from "../../store/actions/vendor/Vendor";
import { saveBookingAirIQ } from "../../store/actions/flights/Flights";
import { uuid } from "uuidv4";
import PassengerList from "./components/Passenger Details/PassengerListV2";
import SelectedFlight from "./components/Selected Flight/SelectedFlight";
import Baggage from "./Baggage";
import PaymentCard from "./components/Payments Card/PaymentsCard";
import Loader from "../Loader/Loader";
import MySnackbar from "../MySnackBar";
import Footer from "../../components/Flight/components/Home Footer/Footer";
import { getCommision } from "../../helpers/general.helper";
import faresData from "./fares.json";
import { ButtonBase, TextField } from "@mui/material";
import FareSummary from "./components/Fare Summary/FareSummary";
import "./index.css";
import { retrieveFromLocalStorage } from "../Common/Utils";
import FlightProviders from "./utils/FlightProviders";

const useStyles = makeStyles((theme) => ({
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: "2%",
    marginBottom: "2%",
    backgroundColor: "var(--white)",
    [theme.breakpoints.down("sm")]: {
      padding: "4%",
    },
  },
  main: {
    marginTop: "2rem",
    marginBottom: "2rem",
    backgroundColor: "var(--backgroundcolor)",
    minHeight: "100vh",
    maxWidth: "80%",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "21%",
    },
  },
}));

let prevPrice = 0;
let prevSearchQuery = "";

function FlightBook(props) {
  const classes = useStyles();
  const journey = useSelector((state) => state.flight.journeyDetails);
  // const {
  //   journeyType,
  //   selectedDepartureDate,
  //   arrivalDate,
  //   departureAirport,
  //   arrivalAirport,
  //   adults: defaultAdults,
  //   kids: defaultKids,
  //   infants: defaultInfants,
  // } = journey;
  const search = useLocation().search;
  const journeyType = new URLSearchParams(search).get("journeyType");
  const selectedDepartureDate = new URLSearchParams(search).get(
    "departureDate"
  );
  const arrivalDate = new URLSearchParams(search).get("arrivalDate");
  const defaultAdults = new URLSearchParams(search).get("adults");
  const defaultKids = new URLSearchParams(search).get("kids");
  const defaultInfants = new URLSearchParams(search).get("infants");
  const flightClass = new URLSearchParams(search).get("flightClass");
  const departureAirport = new URLSearchParams(search).get("departureAirport");
  const arrivalAirport = new URLSearchParams(search).get("arrivalAirport");
  const [adults, setAdults] = useState(defaultAdults);
  const [kids, setKids] = useState(defaultKids);
  const [infants, setInfants] = useState(defaultInfants);
  //const flightClass = useSelector((state) => retrieveFromLocalStorage(state, "selectedFlight").fare_category);
  const session_id = uuid();

  const [flight, setFlight] = useState(null);
  const selectedCurrency = useSelector((state) => state.flight.currency);
  const [bnum, setBnum] = useState(0);
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState(0);
  const [canBook, setCanBook] = useState(false);
  const [baggagePrice, setBaggagePrice] = useState(0);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState({
    show: true,
    message: "",
    type: "",
  });

  const { orderId } = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedCurrency) fetchData();
  }, [selectedCurrency]);

  useEffect(() => {
    document.body.style.overflow = "visible";
  }, []);
  useEffect(() => {
    if (props.passengers && props.passengers.length) {
      let _adults = 0,
        _kids = 0,
        _infants = 0;
      for (let pass of props.passengers) {
        if (pass.category == "adult") _adults++;
        if (pass.category == "child") _kids++;
        if (pass.category == "infant") _infants++;
      }

      setAdults(_adults);
      setKids(_kids);
      setInfants(_infants);
      fetchData(_adults, _kids, _infants);
      if (
        flight &&
        flight.conversion &&
        flight.conversion.amount &&
        flight.total
      ) {
        let totalBaggagePrice = 0;
        for (let pass of props.passengers) {
          if (
            pass.baggage &&
            pass.baggage.checkedBaggage &&
            pass.baggage.checkedBaggage.price
          ) {
            totalBaggagePrice +=
              (flight.conversion.amount / flight.total) *
              pass.baggage.checkedBaggage.price.amount;
          }
          if (
            pass.baggage &&
            pass.baggage.cabinBaggage &&
            pass.baggage.cabinBaggage.price
          ) {
            totalBaggagePrice +=
              (flight.conversion.amount / flight.total) *
              pass.baggage.cabinBaggage.price.amount;
          }
        }
        setBaggagePrice(totalBaggagePrice);
      }
    }
  }, [props.passengers]);

  useEffect(() => {
    if (props.auth) {
      props.getUserDetails();
    }
    if (props.auth && localStorage.getItem("userLoginType") == "vendor") {
      props.getVendorDetails();
    }
  }, [props.auth]);

  useEffect(() => {
    if (props.vendorCurrency)
      dispatch({ type: "SET_CURRENCY", currency: props.vendorCurrency });
    else dispatch({ type: "SET_CURRENCY", currency: props.currency });
  }, [props.vendorCurrency, props.currency]);

  function setSelectedFlight(flight) {
    dispatch({
      type: "SELECTED_FLIGHT",
      flight,
    });
  }
  const createUTCdateForISO = (dateString) => {
    const offset = new Date().getTimezoneOffset();
    const myDate = Date.parse(dateString) + offset * 60 * 1000;
    const dateAsISO = new Date(myDate).toISOString();

    return dateAsISO;
  };
  const fetchData = async (_adults, _kids, _infants) => {
    setLoading(true);

    let queryParam = `/flights/offers-airiq?date_from=${moment(
      selectedDepartureDate
    ).format(
      "yyyy/MM/DD"
    )}&fly_from=${departureAirport}&fly_to=${arrivalAirport}&adults=${adults}&children=${kids}&infants=${infants}`;
    let response = await axios.get(queryParam);
    if (response && response.data && response.data.data) {
      let d = response.data.data;
      d.map((item) => {
        if (item.ticket_id == orderId) {
          const final_flight = {
            ticked_id: item.ticket_id,
            flight_id: item.flight_number.replace(" ", "-"),
            slices: [
              {
                duration:
                  (new Date(`${item.arival_date} ${item.arival_time}`) -
                    new Date(`${item.departure_date} ${item.departure_time}`)) /
                  1000,
                airline: { [item.flight_number.split(" ")[0]]: 1 },
                segments: [
                  {
                    flyFrom: item.origin,
                    flyTo: item.destination,
                    flight_number: item.flight_number.split(" ")[1],
                    fare_category: "M",
                    operating_carrier: item.flight_number.split(" ")[0],
                    airline: item.flight_number.split(" ")[0],
                    local_departure: `${item.departure_date} ${item.departure_time}:00.000Z`,
                    utc_departure: createUTCdateForISO(
                      `${item.departure_date} ${item.departure_time}`
                    ),
                    local_arrival: `${item.arival_date} ${item.arival_time}:00.000Z`,
                    utc_arrival: createUTCdateForISO(
                      `${item.arival_date} ${item.arival_time}`
                    ),
                  },
                ],
              },
            ],
            price: item.price,
            provider: FlightProviders.AIRIQ,
          };
          setPrice(final_flight.price);
          setFlight(final_flight);
          dispatch({
            type: "SELECTED_FLIGHT",
            flight: final_flight,
          });
        }
      });
    }
    setLoading(false);
  };

  const getAirportCode = async (code) => {
    let response = await axios.get(`flights/airports?query=${code}`);
    if (response && response.data && response.data.data) {
    }
  };

  let interval;
  useEffect(() => {
    if (interval) {
      clearInterval(interval);
    }
    interval = setInterval(() => fetchData(), 10000);
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [adults, kids, infants, selectedCurrency]);

  const proceedToPayment = async (token) => {
    const { saveBookingAirIQ, listValid, email, phone } = props;
    const { passengers } = props;

    const exist_Adult = passengers.find((pass) => pass.category == "adult");

    if (!listValid) {
        setShowSnackBar({
            show: true,
            message: "Please fill the mandatory fields in the Passenger list",
            type: "error",
        });
        return;
    }
    if (!exist_Adult) {
        setShowSnackBar({
            show: true,
            message: "Add atleast one adult passenger to continue",
            type: "error",
        });
        return;
    }

    const passengersList = passengers.map((passenger) => {
        return {
            title: passenger.title[0].toUpperCase() + passenger.title.substring(1),
            first_name: passenger.name,
            last_name: passenger.surname,
            category: passenger.category
        };
    });

    const adult_info = passengersList.filter(
        (passenger) => passenger.category === "adult"
    ).map(passenger => ({
        title: passenger.title,
        first_name: passenger.first_name,
        last_name: passenger.last_name
    }));

    const child_info = passengersList.filter(
        (passenger) => passenger.category === "child"
    );
    const infant_info = passengersList.filter(
        (passenger) => passenger.category === "infant"
    );

    let data = {
        fly_from: departureAirport,
        date_from: moment(selectedDepartureDate).format("YYYY-MM-DD"),
        fly_to: arrivalAirport,
        adult: adult_info.length,
        child: child_info.length,
        infant: infant_info.length,
        total_pax: passengers.length,
        adult_info,
        ticket_id: orderId,
        useWallet: token.id === "NOT_REQUIRED",
        email: "test@test.com",
        user_email: "test@test.com",
    };

    

    // let baggage = [];

    // data.passengers = passengers.map((item, i) => {
    //   if (item.baggage && item.baggage.checkedBaggage) {
    //     let checkExistHoldBagIndex =
    //       baggage &&
    //       baggage.findIndex((bag) => bag.combination.category == "hold_bag");
    //     if (checkExistHoldBagIndex != -1) {
    //       baggage[checkExistHoldBagIndex].passengers.push(i);
    //     } else {
    //       baggage.push({
    //         combination: item.baggage.checkedBaggage,
    //         passengers: [i],
    //       });
    //     }
    //   }

    //   if (item.baggage && item.baggage.cabinBaggage) {
    //     let checkExistHandBagIndex =
    //       baggage &&
    //       baggage.findIndex((bag) => bag.combination.category == "hand_bag");
    //     if (checkExistHandBagIndex != -1) {
    //       baggage[checkExistHandBagIndex].passengers.push(i);
    //     } else {
    //       baggage.push({
    //         combination: item.baggage.cabinBaggage,
    //         passengers: [i],
    //       });
    //     }
    //   }
    //   delete item.id;
    //   delete item.baggage;
    //   return item;
    // });
    // data.baggage = baggage;

    // let check_booking_data = {
    //   booking_token: orderId,
    //   adults: passengers.length,
    //   children: kids,
    //   visitor_uniqid: session_id,
    //   journey_type: journeyType,
    //   currency: selectedCurrency,
    // };
    setSubmitLoader(true);
    saveBookingAirIQ(data, session_id)
        .then((res) => {
            setSubmitLoader(false);
            setShowSnackBar({
                show: true,
                message: "Flight booked successfully!",
                type: "success",
            });

            if (localStorage.getItem("userLoginType") == "vendor") {
                props.history.push("/vendor/orders");
            } else {
                props.history.push("/flights");
            }
        })
        .catch((err) => {
            setShowSnackBar({
                show: true,
                message: "Something went wrong!",
                type: "error",
            });
            setSubmitLoader(false);
        });
  };

  const handleBack = () => {
    props.history.goBack();
  };
  return (
    <>
      <div className={`${classes.main} main-container`}>
        <Grid
          container
          className="third-container"
          justifyContent="space-between"
        >
          <Grid xs="12" sm="12" md="9" className="flight-booking">
            <SelectedFlight flight={flight} loading={loading} />
            <PassengerList
              document_options={flight?.document_options}
              childs={kids}
              adults={adults}
              infants={infants}
              selectedCurrency={selectedCurrency}
            />
            <PaymentCard
              adminCommission={{
                type: props.adminCommissionType,
                value: props.adminCommissionValue,
              }}
              flight={flight}
              onSuccess={proceedToPayment}
              canBook={canBook}
            />
            <Loader show={submitLoader} />
          </Grid>
          <FareSummary
            adminCommission={{
              type: props.adminCommissionType,
              value: props.adminCommissionValue,
            }}
            flight={flight}
          />
        </Grid>

        <MySnackbar
          show={showSnackBar.show}
          onClose={() =>
            setShowSnackBar({ show: false, message: "", type: "info" })
          }
          message={showSnackBar.message}
          type={showSnackBar.type}
        />
      </div>
      <Footer />
    </>
  );
}

const mapStateWithProps = (state) => {
  let commissionType = "";
  let commissionValue = 0;
  let vendorCurrency;
  if (state.vendor && state.vendor.vendorDetail) {
    commissionType = state.vendor.vendorDetail.commissionType;
    commissionValue = state.vendor.vendorDetail.commissionValue;
    vendorCurrency = state.vendor.vendorDetail.currency;
  }
  let adminCommissionType = "Fixed";
  let adminCommissionValue = 0;
  if (
    state.admin &&
    state.admin.commission &&
    state.admin.commission.commissionType
  ) {
    adminCommissionType = state.admin.commission.commissionType;
    adminCommissionValue = state.admin.commission.commissionValue;
  }
  return {
    auth: state.user.auth,
    userDetails: state.user.userDetails,
    passengers: state.flight.passengers,
    old_passengers: state.flight.old_pass,
    email: state.flight.email,
    phone: state.flight.phone,
    currency: state.flight.currency ? state.flight.currency : "",
    listValid: state.flight.passengerListValid,
    commissionType: commissionType,
    commissionValue: commissionValue,
    vendorCurrency,
    adminCommissionType,
    adminCommissionValue,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleSignUp: (isOpen) => dispatch(toggleSignUp(isOpen)),
  setSelectedFlight: (flight) => dispatch({ type: "SELECTED_FLIGHT", flight }),
  getUserDetails: () => dispatch(getUserDetails()),
  getVendorDetails: () => dispatch(getVendorDetails()),
  saveBookingAirIQ: (data, session_id) =>
    dispatch(saveBookingAirIQ(data, session_id)),
});

export default connect(mapStateWithProps, mapDispatchToProps)(FlightBook);
